import { Component, OnInit, AfterViewInit, ComponentFactoryResolver, Inject, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';

// import { EventService } from '../core/services/event.service';
import MetisMenu from 'metismenujs/dist/metismenujs';

// import { AuthenticationService } from '../core/services/auth.service';
import { DOCUMENT, NgTemplateOutlet } from '@angular/common';
// import { AuthfakeauthenticationService } from '../core/services/authfake.service';
// import { LanguageService } from '../core/services/language.service';

import { CookieService } from 'ngx-cookie-service';
import { environment } from 'src/environments/environment';
import { AlertService } from '../core/services/alert.service';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
})
export class LayoutComponent implements OnInit, AfterViewInit {
  configData;
  openSwitch = false;

  menu = [
    {
      label: '회원관리',
      subItems: [
        {
          label: '회원관리',
          link: '/dashboard',
        },
      ],
    },
    {
      label: '서비스관리',
      subItems: [
        {
          label: '문의 및 접수 관리',
          link: '/inquiry',
        },
        {
          label: 'Radlot 소개',
          link: '/info',
        },
        {
          label: '이용약관/개인정보처리방침',
          link: '/terms',
        },
      ],
    },
  ];

  constructor(
    // private eventService: EventService,
    private router: Router,
    private route: ActivatedRoute,
    private componentFactoryResolver: ComponentFactoryResolver,
    @Inject(DOCUMENT) private document: any,
    private alertService: AlertService,
    // private authService: AuthenticationService,
    // private authFackservice: AuthfakeauthenticationService,
    // public languageService: LanguageService,

    public _cookiesService: CookieService
  ) {}

  ngOnInit() {
    document.body.setAttribute('data-sidebar', 'dark');
    this.configData = {
      suppressScrollX: true,
      wheelSpeed: 0.3,
    };

    this.configData = {
      suppressScrollX: true,
      wheelSpeed: 0.3,
    };
  }

  @Output() settingsButtonClicked = new EventEmitter();
  @Output() mobileMenuButtonClicked = new EventEmitter();

  isCondensed = false;

  /**
   * on settings button clicked from topbar
   */
  onSettingsButtonClicked() {
    document.body.classList.toggle('right-bar-enabled');
    this.onSettingsButtonClicked();
  }

  /**
   * On mobile toggle button clicked
   */
  onToggleMobileMenu() {
    this.isCondensed = !this.isCondensed;
    document.body.classList.toggle('sidebar-enable');
    document.body.classList.toggle('vertical-collpsed');
    const aTag = document.querySelector<HTMLElement>('.logo');

    // aTag.classList.toggle('hide');

    if (window.screen.width <= 768) {
      console.log('???');

      document.body.classList.remove('vertical-collpsed');
    }
  }

  ngAfterViewInit() {}

  toggleMenu(event) {
    event.currentTarget.nextElementSibling.classList.toggle('mm-show');
  }

  scrollable() {
    document.body.setAttribute('data-layout-scrollable', 'true');
  }

  /**
   * Toggle the menu bar when having mobile screen
   */
  toggleMobileMenu(event: any) {
    event.preventDefault();
    // this.mobileMenuButtonClicked.emit();
  }

  /**
   * Logout the user
   */
  // 로그아웃 처리합니다.
  logout() {
    this.alertService.successConfirm('로그아웃 하시겠습니까?', '', '확인').then(result => {
      if (result) {
        localStorage.clear();
        this.router.navigate(['/account/login']);
        this.alertService.successmsg('로그아웃 되었습니다.', '');
      }
    });
  }

  public hide() {
    document.body.classList.remove('right-bar-enabled');
  }

  open(list, menu) {
    if (list.openSwitch) {
      list.openSwitch = false;
    } else {
      list.openSwitch = true;
      menu.forEach(ele => {
        if (ele != list && ele.openSwitch == true) {
          ele.openSwitch = false;
        }
      });

      return false;
    }
  }
}
